export default class EODLogger {
    user = null
    appVersion = null
    apiKey = null
    realm = null
    environment = null
    appName = null

    url = 'https://logger.ardee.be/api/v1';

    error(message, payload){
        this.sendLog('error', message, payload);
    }

    debug(message, payload){
        this.sendLog('debug', message, payload);
    }

    info(message, payload){
        this.sendLog('info', message, payload);
    }

    warn(message, payload){
        this.sendLog('warn', message, payload);
    }

    sendLog(type, message, payload){
        if(this.environment == 'development'){
            console[type](message, payload);
            return;
        }

        try {
            let origin = payload && payload.origin?payload.origin:'eodLogger';
            if(typeof window != 'undefined'){
                origin = window.location.href;
            } 

            let readableMessage = message;
            if (typeof readableMessage === 'string' || readableMessage instanceof String){
                if(readableMessage.trim() == ''){
                    readableMessage = 'Onbekende fout';
                }
            } else {
                readableMessage = JSON.stringify(readableMessage);
            }

            fetch(this.url+'/logs/'+type, {
                method:'POST',
                headers:{
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    appName: this.appName,
                    user: this.user,
                    organization: this.realm,
                    message: readableMessage,
                    origin: origin,
                    environment: this.environment,
                    payload: {
                        version: this.appVersion,
                        message: message,
                        ...payload
                    }
                })
            }).catch(error => {
                console.log('error sending log', error);
            });
        } catch (error) {
            console.log('error sending log', error);
        }
    }

    init(options){

        if(options.user){
            this.user = options.user;
        }

        if(options.appVersion){
            this.appVersion = options.appVersion;
        }

        if(options.realm){
            this.realm = options.realm;
        }

        if(options.environment){
            this.environment = options.environment;
        }

        if(options.appName){
            this.appName = options.appName;
        }

        const self = this;

        if(this.environment != 'development'){
            console.error = function(message, ...args){
                console.log('Error!', message, args);
                self.error(message, args);
            };
        

            if(typeof window != 'undefined'){
                window.addEventListener("error", function (e) {
                    let message = e;
                    if(e.reason && e.reason.message){
                        message = e.reason.message;
                    } else if (e.reason){
                        message = e.reason;
                    }

                    console.log('Error!', message, e);
                    self.error(message, e);

                    return false;
                })
                
                window.addEventListener('unhandledrejection', function (e) {
                    let message = e;
                    if(e.reason && e.reason.message){
                        message = e.reason.message;
                    } else if (e.reason){
                        message = e.reason;
                    }

                    console.log('Error!', message, e);
                    self.error(message, e);

                    return false;
                })

                window.onerror = function(msg, url, line, col, error) {
                    var extra = !col ? '' : '\ncolumn: ' + col;
                    extra += !error ? '' : '\nerror: ' + error;

                    self.error(msg, {
                        url: url,
                        line: line,
                        extra: extra
                    });

                    var suppressErrorAlert = true;
                    // If you return true, then error alerts (like in older versions of 
                    // Internet Explorer) will be suppressed.
                    return suppressErrorAlert;
                };
            }
        }

        
    }
}